import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import {
  FormArray,
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
} from "@angular/forms";
import { ToastService } from "ng-uikit-pro-standard";

import { DataService } from "./../../data.service";
import { GUID } from "./../../guid";
import { AppConfig } from "./../../config";

@Component({
  selector: "app-newconvertsetting",
  templateUrl: "./newconvertsetting.component.html",
  styleUrls: ["./newconvertsetting.component.scss"],
})
export class NewconvertsettingComponent implements OnInit {
  nodeMapping: any;
  metaobject: any;
  applicationId: string;
  isLoading = false;
  isError = false;
  errorMessage = "";
  objectName = "";
  mode = "";
  metaobjectId = "";
  convertSettingId = "";
  convertSettingName = "";
  convertionObjectId = "";
  convertsettings: any;
  convertionObject = [];
  // id = "";
  metaobjectList = [];
  parentObjects: Array<any>;
  outputObjects: Array<any>;
  currentParentobjectName = "";
  currentParentobjectId = "";
  selectedOptions: any[] = [];
  guid: GUID;
  selectedObjects: any[] = [];
  detailForm = this.fb.group({
    label: "",
    // name: new FormControl({value: '', disabled: true}, Validators.required),
    name: "",
    pluralname: "",
    node: "",
    code: new FormControl({ value: "", disabled: true }, Validators.required),
    topicname: "",
    ownerdefault: "",
    notificationemail: "",
    category: "",
    defaultuser: "",
    parentobjectid: "",
    parentobjectname: "",
    parentobject: new FormControl(
      { value: "", disabled: false },
      Validators.required
    ),
    ownerchange: false,
    emailonerror: false,
    messageonerror: false,
    active: true,
    allowreports: false,
    allowactivities: false,
    trackfieldhistory: false,
    allowsearch: false,
    enablelicensing: false,
    allowworkflow: false,
    notesandattachments: false,
    iconname: "",
  });

  mappingForm = this.fb.group({
    inputobject: new FormControl({ value: "", disabled: true }),
    outputobjectid: "",
    outputobjectname: "",
    // outputobject: "",
    outputobject: [[]]  // Initialize as an empty array for multiple selections

  });
  categorySelect = [
    { value: "Type A", label: "Type A" },
    { value: "Type B", label: "Type B" },
    { value: "Type C", label: "Type C" },
    { value: "Type D", label: "Type D" },
  ];
  ownerSelect = [
    { value: "Record Owner", label: "Record Owner" },
    { value: "System User", label: "System User" },
    { value: "Integration User", label: "Integration User" },
    { value: "Specified User", label: "Specified User" },
  ];
  modifiedby: any;
  modifieddate: any;
  selectedObjectIds: any[];
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private dataService: DataService,
    private toastrService: ToastService,
    private appConfig: AppConfig
  ) {
    if(this.mode.toLocaleLowerCase()=='new'){
    this.mappingForm.valueChanges.subscribe((value) => {
      this.selectedOptions = value.outputobject || [];
    });
  }
  }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.mode = this.route.snapshot.params.mode;
      this.convertSettingId = this.route.snapshot.params.id;
      this.convertSettingName = this.route.snapshot.params.name;
      // this.objectName = this.route.snapshot.params.objectname;
    });
    // this.getConvertSettingsById().then((res) => {
    //   this.retrieveLookupFields();
    // });

    // if (this.mode.toLocaleLowerCase() == "edit") {
    //   this.getConvertSettingsById().then(() => {
    //     // this.retrieveLookupFields();
    //   });
    // }
    // this.getConvertSettingsById().then(() => {
    //   this.retrieveLookupFields();
    // });

    this.getActiveObjectsByType().then((res) => {
      console.log("response11111", res);

      if (this.mode.toLocaleLowerCase() == "edit") {
        this.getConvertSettingsById().then(() => {
          // this.retrieveLookupFields();
        });
      }
      console.log("parentobjects", this.parentObjects);

      //this.detailForm.controls.parentobject.patchValue('');

      // if(this.mode.toLowerCase() == "edit"){

      //   this.getMetaobjectById();
      // }
      // this.retrieveLookupFields();
    });

    console.log(this.mode);
    this.guid = new GUID();
  }
  updateSelectedOptions(event: any) {
    console.log(event)
    this.selectedOptions = event.value;

      
  this.selectedOptions = event.value.map((selectedValue: any) => {
    const selectedObject = this.outputObjects.find(obj => obj.value === selectedValue);
    return {
      value: selectedObject.value,
      label: selectedObject.label
    };
  });
  console.log(this.selectedOptions);

  }
  showSuccess(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-top-right",
      timeOut: 3000,
    };
    this.toastrService.success(data, "", options);
  }

  showError(data: any) {
    let options = { enableHtml: true, positionClass: "md-toast-bottom-right" };
    this.toastrService.error(data, "Metaobject Error!", options);
  }

  showWarning(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-bottom-right",
      messageClass: "orange darken-4",
      toastClass: "warning-color-dark",
    };
    this.toastrService.warning(data, "", options);
  }

  parentObjectChange(event: { value: string; label: any }) {
    console.log("parentObjectChange", event);
    if (event.value.trim() != "") {
      this.detailForm.controls["parentobjectid"].setValue(event.value);
      this.detailForm.controls["parentobjectname"].setValue(event.label);
      this.mappingForm.controls["inputobject"].setValue(event.label);
      // this.currentParentobjectId = event.value;
      // this.currentParentobjectName = event.label;
      // this.retrieveLookupFields();
    } else {
      this.detailForm.controls["parentobjectid"].setValue("");
      this.detailForm.controls["parentobjectname"].setValue("");
    }
  }

  outputObjectChange(event: { value: string; label: any }) {
    console.log("outputObjectChange", event);
    if (event.value.trim() != "") {
      this.mappingForm.controls["outputobjectid"].setValue(event.value);
      this.mappingForm.controls["outputobjectname"].setValue(event.label);
    } else {
      this.mappingForm.controls["outputobjectid"].setValue("");
      this.mappingForm.controls["outputobjectname"].setValue("");
    }
  }

  getActiveObjectsByType() {
    return new Promise((resolve, reject) => {
      console.log("getActiveObjectsByType");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),

        data: {
          metaobject: {
            objecttype: "Domain",
          },
        },
      };
      console.log("postOption", postOption);
      this.isLoading = true;
      this.dataService.getActiveObjectsByType(postOption).subscribe(
        (res) => {
          console.log(res);
          if (res !== null && res.success == 1) {
            var activeObjects = res.data.metaobjects;
            var objArr = [];
            //just add an empty entry sice this field is optional
            // objArr.push({ value: "", label: "--None--" });
            for (let i = 0; i < activeObjects.length; i++) {
              objArr.push({
                value: activeObjects[i].id,
                label: activeObjects[i].name,
              });
            }
            this.parentObjects = objArr;

            this.outputObjects = objArr;

            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No metaobject data!");
            this.errorMessage =
              res != null ? res.message : "No metaobject data!";
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  retrieveLookupFields() {
    return new Promise((resolve, reject) => {
      console.log("LookupFields");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          metafield: {
            metaobjectid: this.currentParentobjectId,
            metaobjectname: this.currentParentobjectName,
            fieldtype: "lookup",
          },
        },
      };
      console.log("postOption", postOption);
      this.isLoading = true;
      this.dataService.getLookupFields(postOption).subscribe(
        (res) => {
          console.log("res", res);

          if (res !== null && res.success == 1) {
            this.metaobjectList = res.metaobject;
            console.log(this.metaobjectList);
            // this.fields = res.data.metafields;
            // this.fieldsToDo = this.fields;
            var objArr = [];
            //just add an empty entry sice this field is optional
            // objArr.push({ value: "", label: "--None--" });
            for (let i = 0; i < this.metaobjectList.length; i++) {
              objArr.push({
                value: this.metaobjectList[i].id,
                label: this.metaobjectList[i].name,
              });
            }
            this.outputObjects = objArr;
            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No  metaobject data!");
            this.errorMessage =
              res != null ? res.message : "No  metaobject data!";
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
          // this.metalayoutbutton.push(button);
        }
      );
    });
  }

  getConvertSettingsById() {
    return new Promise((resolve, reject) => {
      console.log("getConvertSettingsById");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          convertsetting: {
            id: this.convertSettingId,
          },
        },
      };
      console.log("postOption", postOption);
      this.isLoading = true;
      this.dataService.getConvertSettingsById(postOption).subscribe(
        (res) => {
          console.log("res", res);

          if (res.success == 1) {
            // this.process = res.data.process;
            console.log("Doneeee****", res.data.convertsettings.convertionobjectmapping);

            this.convertsettings = res.data.convertsettings;
            this.convertionObject =
              res.data.convertsettings.convertionobjectmapping;

            // if (this.folder != null) {
            this.detailForm.controls["name"].setValue(
              this.convertsettings.name
            );
            this.detailForm.controls["topicname"].setValue(
              this.convertsettings.topicnameformessage
            );
            this.detailForm.controls["notificationemail"].setValue(
              this.convertsettings.notificationemail
            );
            this.detailForm.controls["parentobject"].setValue(
              this.convertsettings.objectid
            );
            this.detailForm.controls["parentobjectid"].setValue(
              this.convertsettings.objectid
            );
            this.detailForm.controls["parentobjectname"].setValue(
              this.convertsettings.objectname
            );
            this.detailForm.controls["ownerdefault"].setValue(
              this.convertsettings.newownerdefault
            );
            this.detailForm.controls["defaultuser"].setValue(
              this.convertsettings.defaultuserspecified
            );
            this.detailForm.controls["category"].setValue(
              this.convertsettings.category
            );
            this.detailForm.controls["ownerchange"].setValue(
              this.convertsettings.allowownerchange
            );
            this.detailForm.controls["emailonerror"].setValue(
              this.convertsettings.sendemailonerror
            );
            this.detailForm.controls["messageonerror"].setValue(
              this.convertsettings.sendmessageonerror
            );
            this.detailForm.controls["active"].setValue(
              this.convertsettings.active
            );

            this.mappingForm.controls["inputobject"].setValue(
              this.convertsettings.objectname
            );

            this.modifiedby = this.convertsettings.modifiedby;
            this.modifieddate = this.convertsettings.modifieddate;
            // this.currentParentobjectId = this.convertsettings.objectid;
            // this.currentParentobjectName = this.convertsettings.objectname;
            // console.log("current object Id", this.currentParentobjectId);
            // console.log("current object name", this.currentParentobjectName);

            this.selectedOptions = this.convertionObject.map((obj: any) => ({
              value: obj.outputobjectid,
              label:obj.outputobjectname
            }));


            // this.selectedOptions = this.convertionObject.map((obj: any) => ({
            //   // label: obj.outputobjectname,
            //   value: obj.outputobjectid,
            // }));

            // if (this.convertionObject.length > 0) {
            //   const outputObjectName = this.convertionObject[0].outputobjectname;
            //   // Setting the value of the outputobject form control
            //   this.mappingForm.controls['outputobject'].setValue([outputObjectName]);
            // }
            this.selectedObjects = this.convertionObject.map(
              (item) => item.outputobjectname
            );

            this.selectedObjectIds = this.convertionObject.map(
              (item) => item.outputobjectid
            );

            // Setting the value of the outputobject form control as an array of outputobjectname values
            // this.mappingForm.controls["outputobject"].setValue(
            //   outputObjectNames
            // );

            // console.log(outputObjectNames);
            // outputObjectNames == this.selectedObjects;

            console.log(this.selectedObjects);
            this.mappingForm.get('outputobject').setValue( this.selectedObjectIds);
            console.log(this.selectedObjectIds);

            console.log(this.selectedOptions);


            // this.convertionObject.map((convertionObj) => ({
            //   inputobjectname: convertionObj.inputobjectname,
            //     // name: folder.name,
            //     // // modifiedby: folder.modifiedby,
            //     // // modifieddate: folder.modifieddate,
            //     // createdby: folder.createdby,
            //     // createddate: folder.createddate,
            //     // parentid: folder.parentfolderid,
            //     // parentfoldername: this.parentfolderName,
            //   }));

            this.isLoading = false;
            resolve(null);
          } else {
            console.log("Error while Retrieving");
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }
cancel(){
  this.router.navigateByUrl("/home/convertsettinglist");

}
  save() {
    this.isLoading = false;
    this.isError = false;
    if (
      this.mappingForm.controls["inputobject"].value.toString().trim() == ""
    ) {
      this.showWarning("Input Object label is mandatory");
      return;
    }

    // if (
    //   this.detailForm.controls["parentobject"].value.toString().trim() == ""
    // ) {
    //   this.showWarning("Input Object label is mandatory");
    //   return;
    // }
    if (this.detailForm.controls["name"].value.toString().trim() == "") {
      this.showWarning("Name is mandatory");
      return;
    }
    if (this.detailForm.controls["category"].value.toString().trim() == "") {
      this.showWarning("Category is mandatory");
      return;
    }

    // if (this.detailForm.invalid) {
    //   this.errorMessage = "The fields [Label] and [Name] are mandatory.";
    //   return;
    // }

    console.log("mode", this.mode);
    if (this.mode.toLowerCase() == "new") {
      this.convertSettingId = this.guid.getGUID("convertsettings");
    }

    //prepare data for saving: application
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      useralias: localStorage.getItem("crm_useralias"),
      data: {
        convertsettings: {
          mode: this.mode,
          id: this.convertSettingId,
          name: this.detailForm.controls["name"].value,
          objectname: this.detailForm.controls["parentobjectname"].value,
          objectid: this.detailForm.controls["parentobjectid"].value,
          allowownerchange: this.detailForm.controls["ownerchange"].value,
          newownerdefault: this.detailForm.controls["ownerdefault"].value,
          defaultuserspecified: this.detailForm.controls["defaultuser"].value,
          category: this.detailForm.controls["category"].value,
          sendemailonerror: this.detailForm.controls["emailonerror"].value,
          sendmessageonerror: this.detailForm.controls["messageonerror"].value,
          notificationemail:
            this.detailForm.controls["notificationemail"].value,
          topicnameformessage: this.detailForm.controls["topicname"].value,
          active: this.detailForm.controls["active"].value,
          convertionobjectmapping: [],
        },
      },
    };

    var arrConvertionObjectMapping = [];
    for (let convertionObj of this.selectedOptions) {
      // if (this.mode.toLowerCase() == "new") {
      this.convertionObjectId = this.guid.getGUID("convertionobject");
      // }
      console.log(convertionObj);
      var convertionobject = {
        mode: this.mode,
        id: this.convertionObjectId,
        convertsettingid: this.convertSettingId,
        inputobjectid: this.detailForm.controls["parentobjectid"].value,
        inputobjectname: this.detailForm.controls["parentobjectname"].value,
        outputobjectid: convertionObj.value,
        outputobjectname: convertionObj.label,
        // outerjoin: reportTypeRelation.outerjoin,
      };
      arrConvertionObjectMapping.push(convertionobject);
    }

    postOption.data.convertsettings.convertionobjectmapping =
      arrConvertionObjectMapping;

    console.log(postOption);

    this.isLoading = true;
    this.dataService.upsertConvertSetting(postOption).subscribe(
      (res) => {
        //alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          this.showSuccess(res.message);
          this.isLoading = false;
          this.router.navigateByUrl("/home/convertsettinglist");
        } else {
          console.log("error while saving");
          this.showError(res.message);
          this.isLoading = false;
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.showError(err.message);
        this.isError = true;
        this.isLoading = false;
      }
    );
  }
}
